export const state = {
  loading: true,
  profile: false,
  profileLoading: false,
  announcements: [],
  announcementsLoading: false,
  games: [],
  gamesLoading: false,
  services: [],
  servicesLoading: false,
  availability: {},
  availabilityLoading: false,
  incomingOrders: [],
  responseError: undefined,
  allowedGames: [],
  providerLobbySessions: [],
  consumerLobbySessions: [],
  edittingLobbySession: false,
};
